import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  isCollapsed: false;
  isAdmin: boolean;

  constructor(
  ) {
    const currentUserJSON = localStorage.getItem("currentUser");
    if (currentUserJSON) {
      const currentUser = JSON.parse(currentUserJSON);
      if (currentUser && currentUser.is_admin) {
        this.isAdmin = currentUser.is_admin;
      } else {
        this.isAdmin = false; // Mặc định là false nếu không có dữ liệu hoặc không có thuộc tính is_admin
      }
    } else {
      this.isAdmin = false; // Mặc định là false nếu không có dữ liệu trong localStorage
    }
  }

  ngOnInit() {    
  }

}
